import Chart from 'chart.js/auto';

const BatteryStatusDistributionChart = {
  chart: null,

  mounted() {
    console.log('BatteryStatusDistributionChart mounted');
    this.initChart();
  },

  updated() {
    console.log('BatteryStatusDistributionChart updated');
    this.updateChart();
  },

  destroyed() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  },

  initChart() {
    try {
      const ctx = this.el.getContext('2d');
      
      const good = parseInt(this.el.dataset.good) || 0;
      const faultyBattery = parseInt(this.el.dataset.faultyBattery) || 0;
      const endOfLife = parseInt(this.el.dataset.endOfLife) || 0;
      
      const totalDevices = good + faultyBattery + endOfLife;

      if (totalDevices === 0) {
        console.log('No data for battery status distribution chart');
        this.renderNoDataMessage();
        return;
      }

      const colors = {
        good: '#10b981',           // green
        faultyBattery: '#ef4444',  // red
        endOfLife: '#6b7280'       // gray
      };

      const hoverColors = {
        good: '#059669',
        faultyBattery: '#dc2626',
        endOfLife: '#4b5563'
      };

      this.chart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: [
            'Good',
            'Faulty Battery',
            'End of Life'
          ],
          datasets: [{
            data: [good, faultyBattery, endOfLife],
            backgroundColor: [
              colors.good,
              colors.faultyBattery,
              colors.endOfLife
            ],
            borderColor: '#ffffff',
            borderWidth: 2,
            hoverBackgroundColor: [
              hoverColors.good,
              hoverColors.faultyBattery,
              hoverColors.endOfLife
            ],
            hoverBorderWidth: 3,
            hoverBorderColor: '#ffffff'
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              position: 'bottom',
              labels: {
                color: '#374151',
                font: { 
                  size: 13,
                  weight: '600'
                },
                padding: 15,
                usePointStyle: true,
                pointStyle: 'circle',
                boxWidth: 12,
                boxHeight: 12
              }
            },
            tooltip: {
              backgroundColor: 'rgba(17, 24, 39, 0.95)',
              titleColor: '#fff',
              bodyColor: '#fff',
              padding: 12,
              cornerRadius: 8,
              displayColors: true,
              boxWidth: 12,
              boxHeight: 12,
              boxPadding: 6,
              titleFont: {
                size: 14,
                weight: '600'
              },
              bodyFont: {
                size: 13,
                weight: '500'
              },
              callbacks: {
                label: function(context) {
                  const label = context.label || '';
                  const value = context.parsed;
                  const percentage = ((value / totalDevices) * 100).toFixed(1);
                  return `${label}: ${value.toLocaleString()} devices (${percentage}%)`;
                }
              }
            }
          },
          cutout: '65%',
          animation: {
            animateRotate: true,
            animateScale: true
          }
        }
      });

      console.log('BatteryStatusDistributionChart initialized successfully');
    } catch (error) {
      console.error('Error initializing BatteryStatusDistributionChart:', error);
    }
  },

  renderNoDataMessage() {
    const ctx = this.el.getContext('2d');
    ctx.clearRect(0, 0, this.el.width, this.el.height);
    ctx.font = '16px Inter, system-ui, sans-serif';
    ctx.fillStyle = '#9CA3AF';
    ctx.textAlign = 'center';
    ctx.fillText('No data available', this.el.width / 2, this.el.height / 2);
  },

  updateChart() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
    this.initChart();
  }
};

export default BatteryStatusDistributionChart;